<template>
  <div class="flex flex-col justify-center items-center pt-2">
    <p
      class="text-base md:text-xl lg:text-2xl md:pt-10 lg:pt-20 text-center text-[#061B44] font-semibold"
    >
      {{ $t("About_Subtitles_tech") }}
    </p>
    <p
      class="text-xs md:text-base text-slate-800 pt-2 text-center font-medium w-[90%] xl:w-[60%]"
    >
      {{ $t("Our_mission_is_to_make") }}
    </p>
    <div
      class="grid grid-cols-1 md:grid-cols-3 xl:grid-cols-4 gap-8 items-start justify-center pt-10 md:pt-20 lg:pt-32 w-[90%] pb-10"
    >
      <div
        v-for="item in firstSection"
        :key="item.id"
        class="flex flex-col items-center justify-start space-y-4"
      >
        <img :src="item.id" alt="" class="h-44" />
        <p
          class="text-[#061B44] text-xl font-bold text-center"
          v-html="item.title"
        ></p>
        <p class="font-medium text-center text-sm">
          {{ item.description }}
        </p>
      </div>
    </div>
    <div class="pt-24"></div>
    <div class="h-10 bg-[#76A2F8] w-full rounded-t-[50%]"></div>
    <div
      class="h-120 bg-[#76A2F8] w-full flex flex-col lg:flex-row items-center justify-center py-12 space-x-4 lg:space-x-20"
    >
      <img
        src="../assets/images/home/05.png"
        alt=""
        class="w-[70%] lg:w-[30%]"
      />
      <div class="flex flex-col items-center lg:items-start w-[90%] lg:w-[40%]">
        <p
          class="text-lg md:text-3xl pt-6 text-center lg:text-start text-white font-semibold"
        >
          {{ $t("Discover_Limitless_Content") }}
        </p>
        <p
          class="text-sm md:text-xl pt-6 text-center lg:text-start text-white font-semibold w-[95%] md:w-[80%] lg:w-[65%]"
        >
          {{ $t("Your_ideal_location_for_professional_video_and_audio") }}
        </p>
      </div>
    </div>
    <div class="h-10 bg-[#76A2F8] w-full rounded-b-[50%]"></div>

    <!-- about us -->
    <div
      class="flex flex-col-reverse lg:flex-row pt-24 lg:space-x-10 justify-center items-center"
    >
      <div class="flex flex-col w-[95%] md:w-[80%] lg:w-[30%]">
        <p
          class="text-lg md:text-3xl pt-6 text-center lg:text-start text-[#304263] font-semibold"
        >
          {{ $t("About_us") }}
        </p>
        <p
          class="text-sm md:text-xl pt-6 text-center lg:text-start text-[#304263] font-semibold"
        >
          {{ $t("atsubtitle") }}
        </p>
      </div>
      <img
        src="../assets/images/home/06.png"
        alt=""
        class="w-[70%] lg:w-[40%]"
      />
    </div>
    <!-- servcice part -->
    <div class="pt-24"></div>
    <div class="h-10 bg-[#76A2F8] w-full rounded-t-[50%]"></div>
    <div class="h-120 bg-[#76A2F8] w-full flex flex-col items-center">
      <p class="text-lg md:text-3xl pt-6 text-start text-white font-semibold">
        {{ $t("Services") }}
      </p>
      <div class="flex flex-row space-x-2 md:space-x-4 items-center pt-6">
        <div
          @click="navToRoute('youtube-transcription')"
          class="flex flex-row space-x-1 md:space-x-4 items-center cursor-pointer"
        >
          <img src="../assets/images/home/01.png" alt="" class="h-7 md:h-10 lg:h-20" />
          <p class="text-xs md:text-sm lg:text-xl font-semibold text-white pr-3">
            {{ $t("Youtube") }}<br />{{ $t("subtitles") }}
          </p>
        </div>
        <div
          @click="navToRoute('video-transcription')"
          class="flex flex-row space-x-1 md:space-x-4 items-center cursor-pointer"
        >
          <img src="../assets/images/home/02.png" alt="" class="h-7 md:h-10 lg:h-20" />
          <p class="text-xs md:text-sm lg:text-xl font-semibold text-white pr-3">
            {{ $t("Video") }}<br />{{ $t("subtitles") }}
          </p>
        </div>
        <div
          @click="navToRoute('audio-transcription')"
          class="flex flex-row space-x-1 md:space-x-4 items-center cursor-pointer"
        >
          <img src="../assets/images/home/03.png" alt="" class="h-7 md:h-10 lg:h-20" />
          <p class="text-xs md:text-sm lg:text-xl font-semibold text-white pr-3">
            {{ $t("Audio") }}<br />{{ $t("to_text") }}
          </p>
        </div>
      </div>
      <p
        class="text-sm md:text-lg py-6 text-center text-white font-semibold w-[95%] md:w-[80%] lg:w-[45%]"
      >
        {{ $t("With_our_easy_to_use_video_player") }}
      </p>
      <router-link
        :to="authStore.token ? '/pricing' : '/signing-up'"
        class="text-[#061B44] text-sm md:text-lg font-semibol h-10"
        ><button
          class="bg-[#061B44] text-white font-semibold py-1 px-12 rounded-full h-10"
        >
          {{ $t("Start_Now") }}
        </button></router-link
      >
    </div>
    <div class="h-10 bg-[#76A2F8] w-full rounded-b-[50%]"></div>
    <!-- video part -->
    <div
      class="flex flex-col lg:flex-row pt-24 lg:space-x-28 justify-center items-center"
    >
      <img
        src="../assets/images/home/07.png"
        alt=""
        class="w-[70%] lg:w-[30%]"
      />
      <div class="flex flex-col w-[80%] lg:w-[30%]">
        <p
          class="text-lg md:text-3xl pt-6 text-center lg:text-start text-[#304263] font-semibold"
        >
          {{ $t("Video_Player_Page") }}
        </p>
        <p
          class="text-sm md:text-xl pt-6 text-center lg:text-start text-[#304263] font-semibold"
        >
          {{ $t("With_our_easy_to_use_video_player") }}
        </p>
      </div>
    </div>
    <!-- user part -->
    <div class="pt-24"></div>
    <div class="h-10 bg-[#76A2F8] w-full rounded-t-[50%]"></div>
    <div class="h-120 bg-[#76A2F8] w-full flex flex-col items-center">
      <div
        class="flex flex-col-reverse lg:flex-row pt-6 lg:space-x-10 justify-center items-center"
      >
        <div
          class="flex flex-col w-[95%] md:w-[80%] lg:w-[30%] items-center lg:items-start"
        >
          <p class="text-lg md:text-3xl pt-6 text-start text-white font-semibold">
            {{ $t("User_Accounts") }}
          </p>
          <p
            class="text-sm md:text-xl py-6 text-center lg:text-start text-white font-semibold"
          >
            {{ $t("Create_your_own_account") }}
          </p>
          <router-link
            :to="authStore.token ? '/pricing#pricing' : '/signing-up'"
            class="text-[#061B44] text-sm md:text-lg font-semibol h-10"
            ><button
              class="bg-[#061B44] text-white font-semibold py-1 px-12 rounded-full h-10"
            >
              {{ $t("Subscribe") }}
            </button></router-link
          >
        </div>
        <img
          src="../assets/images/home/08.png"
          alt=""
          class="w-[50%] lg:w-[25%]"
        />
      </div>
    </div>
    <div class="h-10 bg-[#76A2F8] w-full rounded-b-[50%]"></div>
    <div class="h-120 w-full flex flex-col items-center py-10">
      <p class="text-lg md:text-3xl pt-6 text-center text-[#304263] font-semibold">
        {{ $t("Subscription_Plans") }}
      </p>
      <p
        class="text-sm md:text-xl pt-6 pb-4 text-center text-[#304263] font-semibold w-[80%] lg:w-[40%]"
      >
        {{ $t("explore-our-subs") }}
      </p>
      <router-link
        to="/pricing#pricing"
        class="text-[#061B44] text-sm md:text-lg font-semibol h-10"
        ><button
          class="bg-[#061B44] text-white font-semibold py-1 px-12 rounded-full h-10"
        >
          {{ $t("View_Subscription_Plans") }}
        </button></router-link
      >
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import { useAuthStore } from "../store/auth";
import image01 from '../assets/images/youtube/01.png';
import image02 from '../assets/images/youtube/02.png';
import image03 from '../assets/images/youtube/03.png';
import image04 from '../assets/images/youtube/04.png';
import image05 from '../assets/images/youtube/05.png';
import image06 from '../assets/images/youtube/06.png';
import image07 from '../assets/images/youtube/07.png';
import image08 from '../assets/images/youtube/08.png';
import { useHead } from "@vueuse/head";
import { PRODUCTIONFRONTEND } from "../utils/appConst";

const { t } = useI18n();
const router = useRouter();
const authStore = useAuthStore();
const isProduction = import.meta.env.MODE === "prod";
const basePath = isProduction ? "/assets/images/" : "src/assets/images/";
const firstSection = computed(() => [
  {
    id: image01,
    title: t("for-content-less-than-br-greater-than-creators"),
    description: t(
      "video-bloggers-vloggers-youtubers-and-content-creators-who-want-to-reach-a-global-audience-by-providing-translated-versions-of-their-videos"
    ),
  },
  {
    id: image02,
    title: t("for-marketing-less-than-br-greater-than-professionals"),
    description: t(
      "marketers-aiming-to-create-and-distribute-multilingual-promotional-videos-to-target-audiences-in-different-regions"
    ),
  },
  {
    id: image03,
    title: t("for-educators-less-than-br-greater-than-and-trainers"),
    description: t(
      "teachers-educators-and-trainers-who-want-to-make-educational-content-accessible-to-students-from-diverse-linguistic-backgrounds"
    ),
  },
  {
    id: image04,
    title: t("for-event-less-than-br-greater-than-organizers"),
    description: t(
      "event-organizers-who-want-to-make-event-videos-conferences-or-presentations-accessible-to-a-wider-international-audience"
    ),
  },
  {
    id: image05,
    title: t("for-language-learners"),
    description: t(
      "individuals-learning-a-new-language-who-can-benefit-from-video-content-with-translated-subtitles-for-language-acquisition"
    ),
  },
  {
    id: image06,
    title: t("for-media-and-entertainment-industry"),
    description: t(
      "film-producers-filmmakers-and-media-professionals-looking-to-expand-the-reach-of-their-productions-to-an-international-audience"
    ),
  },
  {
    id: image07,
    title: t("for-businesses-and-corporations"),
    description: t(
      "multinational-corporations-looking-to-ensure-clear-communication-across-global-teams-as-well-as-localize-training-and-informational-videos-for-employees"
    ),
  },
  {
    id: image08,
    title: t("for-e-learning-platforms"),
    description: t(
      "online-learning-platforms-that-wish-to-offer-courses-with-video-content-in-various-languages"
    ),
  },
]);

const navToRoute = (name: string) => {
  router.push(`/${name}`);
};

useHead({
  title: "Industries - Subtitles Tech | AI-Powered Transcription & Translation",
  meta: [
    {
      name: "description",
      content: "Learn more about Subtitles Tech, your go-to platform for AI-powered transcription and translation services. Discover our mission, services, and how we make content accessible globally."
    },
    {
      name: "keywords",
      content: "about Subtitles Tech, AI transcription, video to text, audio to text, automatic subtitles, YouTube transcription, speech-to-text, translation services, AI-powered translation, Multilingual subtitles, AI subtitle generator, Online transcription tool, Automatic video translation, AI-powered accessibility, Speech recognition technology, AI voice-to-text, Best transcription software, Real-time transcription, Multilingual accessibility services"
    },
    {
      property: "og:title",
      content: "About Us - Subtitles Tech | AI-Powered Transcription & Translation"
    },
    {
      property: "og:description",
      content: "Learn more about Subtitles Tech, your go-to platform for AI-powered transcription and translation services. Discover our mission, services, and how we make content accessible globally."
    },
    {
      property: "og:image",
      content: `${PRODUCTIONFRONTEND}assets/Icon-D2oZLO0r.png`
    },
    {
      property: "og:url",
      content: `${PRODUCTIONFRONTEND}about`
    }
  ],
  link: [
    {
      rel: "canonical",
      href: `${PRODUCTIONFRONTEND}about`
    }
  ]
});


</script>
